<app-logo-header></app-logo-header>

<section class="section">
  <!-- Buyer Header Start -->
  <section class="d-table w-100 my-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 text-center">
          <div class="page-next-level">
            <h4 class="title">{{ 'Buyer.Checkouts' | translate }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Body -->
  <div class="container">
    <div class="row">
      <!-- Form Section -->
      <div class="col-md-7">
        <div class="rounded shadow-lg p-4" id="extraFill">
          <h4 class="mb-3">{{ 'Buyer.BillingDetails' | translate }} :</h4>
          <div *ngIf="!eventFlag">
            <div class="row justify-content-center align-items-center"
              *ngFor="let chunk of simplifiedFieldArray">
              <div class="col-12 mb-3" *ngFor="let field of chunk">
                  <app-date-now
                    *ngIf=" field.fieldType=='dateNow'; else other_fields"
                    [hasMinAsTodayDate]="false"
                    [fieldObject]="field"
                    [fieldErrors]="formValidator.formErrors"
                    [formControlRef]="extraFillForm.controls[field.fieldName]"
                    >
                  </app-date-now>
                <ng-template #other_fields>
                  <app-wrapper-field
                    [fieldObject]="field"
                    [fieldErrors]="formValidator.formErrors"
                    [formControlRef]="extraFillForm.controls[field.fieldName]"
                  ></app-wrapper-field>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center mt-4"
            *ngIf="eventFlag">
            <div *ngFor="let eventTicket of eventTickets; let j = index">
              <mat-expansion-panel [expanded]="true" class="my-2"
                                   *ngFor="let ticket of getEventQuantityArray(
                                   eventTicket['ticketQuantity'] || eventTicket['slotQuantity']);
                                   let i = index">
                <mat-expansion-panel-header>
                  <div class="pt-4 pb-2">
                    <i class="fas fa-check-circle text-success"></i>
                    <span class="fw-bold text-primary">
                      {{(eventTicket["ticketName"] || "Calendar ") + " " + (i + 1) + " Info:"}}
                    </span>
                  </div>
                </mat-expansion-panel-header>
                <div class="row justify-content-center align-items-center"
                  *ngFor="let chunk of simplifiedFieldArray">
                  <div class="col-12 mb-2" *ngFor="let field of chunk">
                    <div class="buyer-information">
                        <app-date-now
                        *ngIf=" field.fieldType=='dateNow'; else other_fields"
                        [hasMinAsTodayDate]="false"
                        [fieldObject]="field"
                        [fieldErrors]="formValidator.formErrors"
                        [fieldErrorName]="getEventTicket(eventTicket, i) + '.' + field.fieldName"
                        [formControlRef]="extraFillForm.controls[
                                                                  getEventTicket(eventTicket, i)
                                                                 ].controls[field.fieldName]">
                      </app-date-now>
                      <ng-template #other_fields>
                        <app-wrapper-field
                        [fieldObject]="field"
                        [fieldErrors]="formValidator.formErrors"
                        [fieldErrorName]="getEventTicket(eventTicket, i) +'.'+field.fieldName"
                        [formControlRef]="extraFillForm.controls[
                                                                  getEventTicket(eventTicket, i)
                                                                 ].controls[field.fieldName]">
                      </app-wrapper-field>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="w-100 text-center mt-2"
                      *ngIf="(vpihs.viewInfoObject.extras?.selectedTickets?.length > 1 ||
                      eventTicket['ticketQuantity'] > 1 ||
                      vpihs.viewInfoObject.extras?.selectedSlots?.length > 1 ||
                      eventTicket['slotQuantity'] > 1) && (j > 0 || i > 0)">
                  <button class="btn btn-primary"
                    (click)="copyFromMain((eventTicket['ticketName'] ||
                    eventTicket['slotId']) + (i + 1))">
                    Copy from main
                  </button>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      </div>
      <!-- Payment Section -->
      <div class="col-md-5 mt-4 mt-sm-0 pt-2">
        <div class="rounded shadow-lg p-4 sticky-bar" id="paymentOptions">
          <!-- Seller Name -->
          <div class="payment-card mb-4">
            <div class="payment-card-header">{{ 'Buyer.Seller' | translate }}</div>
            <div class="payment-card-body">
              {{ businessObject?.name }}
            </div>
          </div>
          <!-- Payment Options -->
          <div class="invoice-middle pb-4 border-bottom">
            <div [ngClass]="{'border border-2 border-danger rounded p-2': paymentValidation}">
              <!-- payment -->
              <app-buyer-payment-options [expired]="expired"
                                         [businessId] = "vpihs.viewInfoObject.product.Business.id"
                                         [totalAmount]="vpihs.total"
                                         [productId]="vpihs.viewInfoObject?.product.id"
                                         (clickEvent)="handleBuyerOptionclickEvent()">
              </app-buyer-payment-options>
            </div>
            <div class="text-danger" *ngIf="paymentValidation">
              {{ 'Buyer.ChoosePaymentMethod' | translate }}
            </div>
          </div>
          <div class="table-responsive overflow-x-hidden">
            <!-- Invoice Info -->
            <table class="table table-center table-padding mb-0">
              <tbody>
                <tr>
                  <td class="fs-6 border-0">{{ 'Buyer.Subtotal' | translate }}</td>
                  <td class="text-end fw-bold border-0 pt-4">
                    {{ vpihs.subTotal.toFixed(2) }} {{ vpihs.currency }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-6 border-0">{{ 'Buyer.Taxes' | translate }}</td>
                  <td class="text-end fw-bold border-0">
                    {{ vpihs.taxes.toFixed(2) }} {{ vpihs.currency }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-6 border-0">{{ 'Buyer.Discount' | translate }}</td>
                  <td class="text-end fw-bold border-0">
                    {{ vpihs.discount.toFixed(2) }} {{ vpihs.currency }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-6">{{ 'Buyer.Fees' | translate }}</td>
                  <td class="text-end fw-bold">
                    {{ vpihs.fees.toFixed(2) }} {{ vpihs.currency }}
                  </td>
                </tr>
                <tr class="bg-light">
                  <td class="fs-5 fw-bold">{{ 'Buyer.Total' | translate }}</td>
                  <td class="text-end text-primary fs-4 fw-bold">
                    {{ vpihs.total.toFixed(2) }} {{ vpihs.currency }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-4 pt-2">
              <!-- Promo Code -->
              <div class="row mb-3">
                <div class="input-group">
                  <input name="promoCode"
                         id="promoCode"
                         type="text"
                         class="form-control"
                         placeholder="{{ 'Sellers.Products.PromoCode' | translate }}"
                         required
                         [(ngModel)]="code" />
                  <div class="input-group-append">
                    <button class="btn btn-primary" (click)="applyPromoCode()">
                      {{ 'Buyer.ApplyCode' | translate }}
                    </button>
                  </div>
                </div>
                <div class="text-danger" *ngIf="formValidator.formErrors.code">
                  {{ formValidator.formErrors.code | titlecase }}
                </div>
              </div>
              <div class="form-check mb-3" *ngFor="let donation of donations">
                <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                       (change)="setDonation(donation.name)" [checked]="donation.selected">
                <label id="flexCheckLabel" class="form-check-label" for="flexCheckDefault">
                  {{ 'BUYER_INFO.DONATION.MSG' | translate:{ donationField:donation.amount.toFixed(2),
                                                              currencyField:vpihs.currency,
                                                              totalField:(vpihs.total+donation.amount).toFixed(2) } }}
                  <a class="text-primary" href="https://mersal-ngo.org/" target="_blank">
                    {{ 'BUYER_INFO.DONATION.DONATION_LINK' | translate }}
                  </a>
                </label>
              </div>
              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" id="flexCheckDefault" [checked]="true"
                       (change)="acceptTerms()" [ngClass]="{'border-2 border-danger': termsError}">
                <label id="flexCheckLabel" class="form-check-label" for="flexCheckDefault">
                  {{ 'Buyer.Accepted' | translate }}
                  <a class="text-primary" routerLink="/terms" target="_blank">
                    {{ 'Buyer.Policies' | translate }}
                  </a>
                  <span class="text-danger">*</span>
                </label>
                <small class="text-danger" *ngIf="termsError">{{ 'Buyer.AcceptConditions' | translate }}</small>
              </div>
              <div class="d-grid gap-2">
                <button class="btn btn-primary" [disabled]="!enableSubmit" (click)="submitWrapper()">
                  {{ 'Buyer.PlaceOrder' | translate }}<span class="loader-order" *ngIf="!enableSubmit"></span>
                </button>
                <!-- <apple-pay-payment-option *ngIf="appleVipsCalculatorService.dataIsReady" [validateBuyerInputs] = "validateBuyerInputs.bind(this)" [submitBuyerDataFunction] = "submit.bind(this)"></apple-pay-payment-option> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="container">
  <app-new-gate-lightbox></app-new-gate-lightbox>
  <app-light-box-upg></app-light-box-upg>
  <app-pay-mob-lightbox></app-pay-mob-lightbox>
  <app-valu-lightbox></app-valu-lightbox>
  <div *ngIf="isReceiptReady">
    <app-receipt id="receipt" hidden></app-receipt>
  </div>
</div>
